<template>
  <VLoader v-if="loading" />
  <section v-else class="shared-section">
    <header class="flex-wrap shared-section-header">
      <h2 class="shared-section-header-heading">{{ $t('postTraining.heading') }}</h2>
      <h3 class="w-full mt-1 text-sm font-semibold tracking-wide text-ricoma-gray-700">
        {{ $t('postTraining.subheading') }}
      </h3>
    </header>
    <ul class="block sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <li class="mb-3" v-for="(product, index) in removedDuplicateProducts" :key="index">
        <Product
          :product="product"
          :isPostTraining="true"
          :outermostLinkTo="{
            name: 'post-training-lessons',
            params: { id: product.id || 0 },
          }"
        />
      </li>
    </ul>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import { removeDuplicates, safeNullDataset } from '@/utils';

import VLoader from '@/components/base/VLoader';
import Product from '@/components/customer/Product';

export default {
  name: 'PostTraining',
  components: { Product, VLoader },
  data() {
    return {
      loading: false,
    };
  },
  computed: mapState({
    products: state => safeNullDataset(state)(['customer', 'products']),
    filteredProducts() {
      return this.products.filter(p => p.is_finish_pretraining && p.has_post_training_videos);
    },
    removedDuplicateProducts() {
      return removeDuplicates(this.filteredProducts, 'id');
    },
  }),
  mounted() {
    if (!this.products.length) {
      this.loading = true;
      this.$store.dispatch('customer/getProducts').then(() => (this.loading = false));
    }
  },
};
</script>
